<template>
  <div :class="['carousel-controls', orientation, position, { inline }]">
    <div
      v-for="i in count"
      :key="i"
      :class="['carousel-controls-dot', { round, selected: i - 1 === value }]"
      :style="i - 1 === value ? dotSelectedStyle : dotStyle"
      @click="$emit('input', i - 1)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },

    count: {
      type: Number,
      default: 0,
    },

    round: {
      type: Boolean,
      default: true,
    },

    orientation: {
      type: String,
      default: 'horizontal',
    },

    position: {
      type: String,
      default: 'end',
    },

    inline: {
      type: Boolean,
      default: false,
    },

    dotStyle: {
      type: Object,
      required: false,
    },

    dotSelectedStyle: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped lang="postcss">
.carousel-controls {
  @apply h-auto flex flex-row justify-center items-center gap-x-micro;

  &:not(.inline) {
    @apply absolute w-full p-xxs;

    &.horizontal {
      &.start {
        @apply top-0;
      }

      &.end {
        @apply bottom-0;
      }
    }

    &.vertical {
      &.start {
        @apply left-0;
      }

      &.end {
        @apply right-0;
      }

      &.start,
      &.end {
        @apply right-0 h-full w-auto flex-col gap-y-micro;
      }
    }
  }

  &-dot {
    @apply bg-neutral-white w-micro h-micro cursor-pointer shadow-md transition-all;

    &:not(.selected) {
      @apply opacity-60;
    }

    &:hover {
      @apply opacity-100;
    }

    &.round {
      @apply rounded-circular;
    }

    &.selected {
      @apply scale-125;
    }
  }
}
</style>
